import { defineStore } from 'pinia';
import ILevel from '../interfaces/iLevel';
import levelsJson from './data/levels.json';

const levels: ILevel[] = levelsJson;

export const useLevelStore = defineStore('levelStore', 
{
    state: () =>
    ({
    }),

    getters:
    {
        levels: () =>
        {
            return levels;
        }
    },

    actions: 
    {
    }
});
